import { type PropsWithChildren, type ReactNode } from 'react';

import { Disclosure, DisclosurePanel, DisclosureTitle } from './disclosure';

export type PlotSectionProps = PropsWithChildren<{
  sectionName: ReactNode;
}>;
export function PlotSection({ children, sectionName }: PlotSectionProps) {
  return (
    <Disclosure className="w-full min-w-[1000px]">
      {({ open }: { open: boolean }) => (
        <>
          <DisclosureTitle>
            <span>{sectionName}</span>
          </DisclosureTitle>

          {/* Render the content conditionally based on `open` */}
          {open ? (
            <DisclosurePanel className="w-full">
              <div className="flex h-auto flex-col items-start justify-start self-stretch py-4">
                {children}
              </div>
            </DisclosurePanel>
          ) : null}
        </>
      )}
    </Disclosure>
  );
}
